/**
 * IPH Keycloak role (§2 · 노션 '접근 권한' 페이지).
 *
 * | role    | 역할          | 대표 권한                                   |
 * |---------|---------------|---------------------------------------------|
 * | USER    | 구매실무자    | MRP 계산·발주 예정·상신·전송. 전체 PO 는 **본인 담당만** |
 * | MANAGER | 구매검토자    | 실무자 전체 + 상신 PO 승인/반려, 구매 지표, 생산계획 편집 |
 * | ADMIN   | 시스템 관리자 | 기준정보 관리, 시스템 설정, 협력사 권한 관리 |
 *
 * 화면 접근은 §2 표를 따른다 — IPH-04·IPH-11 은 MANAGER 전용,
 * IPH-12 는 ADMIN 전용, 나머지는 USER 도 접근 가능하다.
 */
export const IPH_ROLE = {
  USER: 'USER',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
} as const;

export type IphRole = (typeof IPH_ROLE)[keyof typeof IPH_ROLE];
